import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cx-order-confirmation-page',
  templateUrl: './order-confirmation-page.component.html',
  styleUrls: ['./order-confirmation-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderConfirmationPageComponent {}
